import { UAM_URL } from './externalLinks';
import { isLoopbackHost } from './loopbackHost';
import { resolveMarkbaseProductionAppHostname } from './markbaseSpaHosts';
import { billingApiPath } from './billingApiPaths';

export { isLoopbackHost };

// ===================================================
// ФАЙЛ: frontend/src/utils/constants.js
// ✅ ИСПРАВЛЕНО: API endpoints приведены в соответствие с бэкендом
// ===================================================

// =====================================
// API Endpoints (ИСПРАВЛЕНО под бэкенд)
// =====================================
export const API_ENDPOINTS = {
  // Авторизация
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  REFRESH: '/api/auth/refresh',
  LOGOUT: '/api/auth/logout',
  ME: '/api/auth/me',
  /** Публичные метаданные приложения (подвал, VersionBadge) — без авторизации */
  PUBLIC_APP_INFO: '/api/public/app-info',
  CHANGE_PASSWORD: '/api/auth/change-password',
  FORGOT_PASSWORD: '/api/auth/forgot-password',
  RESET_PASSWORD: '/api/auth/reset-password',
  GUEST_LOGIN: '/api/auth/guest-login',

  // Товары
  PRODUCTS: '/api/products',
  PRODUCT_DETAILS: '/api/products/:id',
  BRANDS: '/api/dictionaries/brands',
  PRODUCTS_IMPORT: '/api/product-import',
  PRODUCTS_EXPORT: '/api/products/export',
  PRODUCTS_BULK_FILE_IMPORT: '/api/products/bulk-file/import',
  PRODUCTS_SEARCH: '/api/products/search',
  PRODUCTS_BULK_UPDATE: '/api/products/bulk-update',
  PRODUCTS_BULK_DELETE: '/api/products/bulk-delete',
  PRODUCTS_CATEGORIES: '/api/dictionaries/categories',

  // Группы товаров (вариации)
  PRODUCT_GROUPS: '/api/product-groups',
  PRODUCT_GROUP_DETAILS: '/api/product-groups/:id',
  PRODUCT_GROUP_VARIATIONS: '/api/product-groups/:id/variations',
  PRODUCT_GROUP_ADD_VARIATION: '/api/product-groups/:id/variations',
  PRODUCT_GROUP_REMOVE_VARIATION: '/api/product-groups/:id/variations/:productId',
  PRODUCT_GROUP_REORDER_VARIATIONS: '/api/product-groups/:id/variations/reorder',
  PRODUCT_GROUP_SUGGEST_SIMILAR: '/api/product-groups/suggest/:productId',
  PRODUCT_GROUP_CREATE_FROM_PRODUCTS: '/api/product-groups/create-from-products',
  PRODUCT_GROUP_AUTO_ANALYZE: '/api/product-groups/auto-analyze',
  PRODUCT_GROUP_MERGE_SELECTED: '/api/product-groups/merge-selected',
  PRODUCT_GROUP_MERGE_HISTORY: '/api/product-groups/merge-history',

  // Импорт товаров (product-import)
  PRODUCT_IMPORT_HARVEST_DICTIONARIES: '/api/product-import/harvest-dictionaries',
  PRODUCT_IMPORT_FETCH_BRANDS: '/api/product-import/fetch-brands',
  PRODUCT_IMPORT_FETCH_CATEGORIES: '/api/product-import/fetch-categories',
  PRODUCT_IMPORT_STATUS: '/api/product-import/status/:sessionId',
  PRODUCT_IMPORT_SUPPLIER_CATEGORIES: '/api/product-import/supplier-categories/:supplierId',
  PRODUCT_IMPORT_IMPORT: '/api/product-import/import',
  PRODUCT_IMPORT_CALCULATE: '/api/product-import/calculate',
  PRODUCT_IMPORT_SUPPLIER_BRANDS: '/api/product-import/supplier-brands/:supplierId',
  PRODUCT_IMPORT_SESSIONS: '/api/product-import/sessions',

  // Склады
  WAREHOUSES: '/api/warehouses',
  WAREHOUSE_DETAILS: '/api/warehouses/:id',
  WAREHOUSE_TRANSFER: '/api/warehouses/transfer',
  WAREHOUSE_STOCK: '/api/warehouses/:id/stock',
  WAREHOUSE_MOVEMENTS: '/api/warehouses/:id/movements',
  WAREHOUSE_UPDATE_STOCK: '/api/warehouses/stock',

  // Синхронизация
  SYNC_STOCK: '/api/sync/stock',
  SYNC_ORDERS: '/api/sync/orders',
  SYNC_LOGS: '/api/sync/history',
  SYNC_STATUS: '/api/sync/status',

  // Поставщики
  SUPPLIERS: '/api/suppliers',
  SUPPLIER_DETAILS: '/api/suppliers/:id',
  SUPPLIER_PRODUCTS: '/api/suppliers/:id/products',
  SUPPLIER_SYNC: '/api/suppliers/:id/sync',

  // Маркетплейсы
  MARKETPLACES: '/api/marketplaces',
  MARKETPLACE_DETAILS: '/api/marketplaces/:id',
  MARKETPLACE_ORDERS: '/api/marketplaces/:id/orders',
  MARKETPLACE_CONNECT: '/api/marketplaces',
  MARKETPLACE_TEST: '/api/marketplaces/:id/test',

  // Заказы
  ORDERS: '/api/orders',
  ORDER_DETAILS: '/api/orders/:id',
  ORDER_STATUS: '/api/orders/:id/status',
  ORDERS_BULK_UPDATE: '/api/orders/bulk-update',
  ORDERS_EXPORT: '/api/orders/export',

  // Пользователи
  USERS: '/api/users',
  USER_DETAILS: '/api/users/:id',

  // Аналитика (v1 API — App Dashboard: dashboard + dashboard-settings; отчёты — services/analyticsV1.js)
  ANALYTICS_DASHBOARD: '/api/analytics/v1/dashboard',
  ANALYTICS_DASHBOARD_SETTINGS: '/api/analytics/v1/dashboard-settings',

  // Биллинг (префикс SoT — **`billingApiPaths.js`**, см. **T-R3**)
  BILLING_TARIFFS: billingApiPath('tariffs'),
  BILLING_USAGE: billingApiPath('usage'),
  BILLING_CURRENT_TARIFF: billingApiPath('current-tariff'),
  BILLING_SUBSCRIPTION_INFO: billingApiPath('subscription-info'),
  BILLING_TRANSACTIONS: billingApiPath('transactions'),
  BILLING_CHANGE_TARIFF: billingApiPath('change-tariff'),
  BILLING_CREATE_PAYMENT_INTENT: billingApiPath('create-payment-intent'),

  // Админка
  ADMIN_MONITORING_PROCESSES: '/api/admin/monitoring/processes',
  ADMIN_MONITORING_METRICS: '/api/admin/monitoring/metrics',
  ADMIN_MONITORING_HEALTH: '/api/admin/monitoring/system-health',
  ADMIN_MONITORING_LOGS: '/api/admin/monitoring/logs',
  ADMIN_MONITORING_LOGS_CLEAR: '/api/admin/monitoring/logs/clear',

  // Глобальный поиск (через модуль SEARCH или напрямую)
  GLOBAL_SEARCH: '/api/global-search',
  GLOBAL_SEARCH_VIA_MODULE: '/api/proxy/search/query',

  // Настройки
  SETTINGS_PROFILE: '/api/settings/profile',
  SETTINGS_INTEGRATIONS: '/api/settings/integrations',
  SETTINGS_NOTIFICATIONS: '/api/notifications/preferences/company',
  SETTINGS_API_KEYS: '/api/settings/api-keys',
  SETTINGS: '/api/settings',

  // Валюты
  CURRENCIES: '/api/currencies',

  // Словари
  DICTIONARIES: '/api/dictionaries',
  DICTIONARIES_BRANDS: '/api/dictionaries/brands',
  DICTIONARIES_CATEGORIES: '/api/dictionaries/categories',
  DICTIONARIES_ATTRIBUTES: '/api/dictionaries/attributes',

  // Интеграции
  INTEGRATIONS_TEST_SUPPLIER: '/api/integrations/supplier/test', // Унифицированный тест поставщика
  INTEGRATIONS_TEST_YANDEX: '/api/integrations/yandex/test',
  INTEGRATIONS_SAVE_SUPPLIER: '/api/suppliers/credentials', // Унифицированное сохранение креденциалов
  INTEGRATIONS_SAVE_YANDEX: '/api/integrations/yandex/save',
  INTEGRATIONS_START_SYNC: '/api/integrations/sync/start',

  // Аудит
  AUDIT_LOGS: '/api/audit',
  AUDIT_EXPORT: '/api/audit/export/:format',

  // Здоровье системы
  HEALTH: '/health',
  HEALTH_LIVE: '/health/live',
  HEALTH_READY: '/health/ready',

  // Импорт из файлов (File Import)
  FILE_IMPORT_UPLOAD: '/api/file-import/upload',
  FILE_IMPORT_UPLOAD_FROM_URL: '/api/file-import/upload-from-url',
  FILE_IMPORT_UPDATE_FILE: '/api/file-import/update-file',
  FILE_IMPORT_PREVIEW: '/api/file-import/preview',
  FILE_IMPORT_AVAILABLE_FIELDS: '/api/file-import/available-fields',
  FILE_IMPORT_MAPPING: '/api/file-import/mapping',
  FILE_IMPORT_TEMPLATES: '/api/file-import/templates',
  FILE_IMPORT_APPLY_TEMPLATE: '/api/file-import/apply-template',
  FILE_IMPORT_UPDATE_TEMPLATE: '/api/file-import/templates/:id',
  FILE_IMPORT_FILES: '/api/file-import/files',
  FILE_IMPORT_DELETE_FILE: '/api/file-import/files/:id',
  FILE_IMPORT_EXECUTE: '/api/file-import/execute',
  FILE_IMPORT_STATUS: '/api/file-import/status/:config_id',
  FILE_IMPORT_LOGS: '/api/file-import/logs',
  FILE_IMPORT_MANAGE: '/api/file-import/manage',
};

/**
 * URL для глобального поиска.
 * При REACT_APP_USE_SEARCH_MODULE_PROXY=true — через модуль SEARCH (/api/proxy/search/query).
 * Иначе — напрямую в main backend (/api/global-search).
 */
export const getGlobalSearchApiUrl = () =>
  (process.env.REACT_APP_USE_SEARCH_MODULE_PROXY === 'true'
    ? API_ENDPOINTS.GLOBAL_SEARCH_VIA_MODULE
    : API_ENDPOINTS.GLOBAL_SEARCH);

// =====================================
// Storage Keys
// =====================================
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'userData',
  SESSION_ID: 'sessionId',
  THEME: 'theme',
  LANGUAGE: 'language',
  PREFERENCES: 'userPreferences',
  DASHBOARD_LAYOUT: 'dashboardLayout',
  LAST_LOGIN_METHOD: 'lastLoginMethod',
  LAST_LOGIN_IDENTIFIER: 'lastLoginIdentifier',
  LAST_LOGIN_AT: 'lastLoginAt',
};



// =====================================
// Source Types (из БД)
// =====================================
export const SOURCE_TYPES = {
  MANUAL: 'manual',
  IMPORT: 'import',
  API: 'api'
};

export const SOURCE_TYPE_LABELS = {
  [SOURCE_TYPES.MANUAL]: 'Ручной ввод',
  [SOURCE_TYPES.IMPORT]: 'Импорт',
  [SOURCE_TYPES.API]: 'API'
};

export const SOURCE_TYPE_COLORS = {
  [SOURCE_TYPES.MANUAL]: 'blue',
  [SOURCE_TYPES.IMPORT]: 'green',
  [SOURCE_TYPES.API]: 'purple'
};

// =====================================
// Pricing: human-readable field labels (RU)
// Единый словарь для UI (конфигуратор/карточка/таблицы).
// Позже можно обернуть в i18n и добавить другие языки.
// =====================================
export const PRICE_FIELD_LABELS_RU = {
  auto: 'Авто',

  // supplier_prices fields
  price_without_vat: 'Закупочная поставщика (без НДС)',
  base_price: 'Закупочная поставщика (базовая, без НДС)',
  sale_price: 'Закупочная поставщика (со скидкой)',
  price_with_vat: 'Закупочная поставщика (с НДС)',

  retail_price: 'Розница поставщика (без НДС)',
  retail_price_with_vat: 'Розница поставщика (с НДС)',

  mrc_price: 'МРЦ поставщика (без НДС)',
  mrc_price_with_vat: 'МРЦ поставщика (с НДС)',
  has_mrc: 'Есть МРЦ',

  rrp_price: 'РРЦ поставщика (без НДС)',

  // product_prices fields (our prices)
  purchase_price: 'Закупочная цена',
  price: 'Розничная цена',
};

export const priceFieldLabelRu = (key, fallback = null) => {
  const k = String(key || '').trim();
  if (!k) return fallback;
  return PRICE_FIELD_LABELS_RU[k] || fallback || k;
};

// =====================================
// Base Units (из БД)
// =====================================
export const BASE_UNITS = {
  PIECE: 'шт',
  KG: 'кг',
  LITER: 'л',
  METER: 'м',
  SQUARE_METER: 'м²',
  CUBIC_METER: 'м³'
};

export const BASE_UNIT_LABELS = {
  [BASE_UNITS.PIECE]: 'Штуки',
  [BASE_UNITS.KG]: 'Килограммы',
  [BASE_UNITS.LITER]: 'Литры',
  [BASE_UNITS.METER]: 'Метры',
  [BASE_UNITS.SQUARE_METER]: 'Квадратные метры',
  [BASE_UNITS.CUBIC_METER]: 'Кубические метры'
};

// =====================================
// Subscription Statuses (из БД)
// =====================================
export const SUBSCRIPTION_STATUSES = {
  TRIAL: 'trial',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled'
};

export const SUBSCRIPTION_STATUS_LABELS = {
  [SUBSCRIPTION_STATUSES.TRIAL]: 'Пробный период',
  [SUBSCRIPTION_STATUSES.ACTIVE]: 'Активна',
  [SUBSCRIPTION_STATUSES.EXPIRED]: 'Истекла',
  [SUBSCRIPTION_STATUSES.CANCELLED]: 'Отменена'
};

// =====================================
// Warehouse Types (из БД)
// =====================================
export const WAREHOUSE_TYPES = {
  MAIN: 'main',
  REGIONAL: 'regional',
  PICKUP: 'pickup',
  VIRTUAL: 'virtual'
};

export const WAREHOUSE_TYPE_LABELS = {
  [WAREHOUSE_TYPES.MAIN]: 'Основной',
  [WAREHOUSE_TYPES.REGIONAL]: 'Региональный',
  [WAREHOUSE_TYPES.PICKUP]: 'Пункт выдачи',
  [WAREHOUSE_TYPES.VIRTUAL]: 'Виртуальный'
};

// =====================================
// Supplier Types (из БД)
// =====================================
// NOTE: Типы поставщиков определены ниже в унифицированном блоке.



// =====================================
// Order Statuses (из БД)
// =====================================
export const ORDER_STATUSES = {
  NEW: 'new',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  RETURNED: 'returned'
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUSES.NEW]: 'Новый',
  [ORDER_STATUSES.CONFIRMED]: 'Подтверждён',
  [ORDER_STATUSES.PROCESSING]: 'В обработке',
  [ORDER_STATUSES.SHIPPED]: 'Отправлен',
  [ORDER_STATUSES.DELIVERED]: 'Доставлен',
  [ORDER_STATUSES.CANCELLED]: 'Отменён',
  [ORDER_STATUSES.RETURNED]: 'Возвращён',
};

/**
 * Семантические ключи бейджей. UI-маппинг → DS-классы `mb-badge--*`
 * выполняется в компонентах (см. OrdersTable.BADGE_CLASS_MAP).
 * Канон Wave 1 / ORDERS: цвета AntD-эпохи (`blue/cyan/orange`) запрещены —
 * нужны semantic-токены, понятные DS.
 */
export const ORDER_STATUS_COLORS = {
  [ORDER_STATUSES.NEW]: 'brand',
  [ORDER_STATUSES.CONFIRMED]: 'info',
  [ORDER_STATUSES.PROCESSING]: 'warning',
  [ORDER_STATUSES.SHIPPED]: 'info',
  [ORDER_STATUSES.DELIVERED]: 'success',
  [ORDER_STATUSES.CANCELLED]: 'error',
  [ORDER_STATUSES.RETURNED]: 'warning',
};

// =====================================
// Product Statuses (из БД)
// =====================================
export const PRODUCT_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  OUT_OF_STOCK: 'out_of_stock',
  DISCONTINUED: 'discontinued',
  DRAFT: 'draft'
};

export const PRODUCT_STATUS_LABELS = {
  [PRODUCT_STATUSES.ACTIVE]: 'Активный',
  [PRODUCT_STATUSES.INACTIVE]: 'Неактивный',
  [PRODUCT_STATUSES.OUT_OF_STOCK]: 'Нет в наличии',
  [PRODUCT_STATUSES.DISCONTINUED]: 'Снят с производства',
  [PRODUCT_STATUSES.DRAFT]: 'Черновик'
};

export const PRODUCT_STATUS_COLORS = {
  [PRODUCT_STATUSES.ACTIVE]: 'green',
  [PRODUCT_STATUSES.INACTIVE]: 'default',
  [PRODUCT_STATUSES.OUT_OF_STOCK]: 'orange',
  [PRODUCT_STATUSES.DISCONTINUED]: 'red',
  [PRODUCT_STATUSES.DRAFT]: 'default'
};

// =====================================
// Маршруты
// =====================================
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',

  // Основные страницы
  PRODUCTS: '/products',
  PRODUCTS_CREATE: '/products/new',
  PRODUCTS_EDIT: '/products/:id/edit',

  ORDERS: '/modules/orders',
  ORDERS_DETAILS: '/modules/orders',

  WAREHOUSES: '/warehouses',
  WAREHOUSES_CREATE: '/warehouses/new',
  WAREHOUSES_EDIT: '/warehouses/:id/edit',

  MARKETPLACES: '/marketplaces',
  SUPPLIERS: '/suppliers',
  USERS: '/users',
  ANALYTICS: '/analytics',
  SYNC: '/sync',

  // Настройки
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_INTEGRATIONS: '/settings?tab=integrations',
  SETTINGS_NOTIFICATIONS: '/notifications',
  SETTINGS_API_KEYS: '/settings/api-keys',
};

// =====================================
// Роли пользователей (на основе БД)
// =====================================
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',  // Системный администратор (доступ к системной админке)
  PLATFORM_ADMIN: 'platform_admin', // Платформенный администратор
  OWNER: 'owner',              // Владелец компании (полный доступ к СВОЕЙ компании)
  ADMIN: 'admin',              // Администратор компании
  MANAGER: 'manager',          // Менеджер
  OPERATOR: 'operator',        // Оператор
  VIEWER: 'viewer',            // Просмотр
  USER: 'user',                // Базовый пользователь
};

export const USER_ROLE_LABELS = {
  [USER_ROLES.SUPER_ADMIN]: 'Суперадминистратор',
  [USER_ROLES.PLATFORM_ADMIN]: 'Администратор платформы',
  [USER_ROLES.OWNER]: 'Владелец',
  [USER_ROLES.ADMIN]: 'Администратор',
  [USER_ROLES.MANAGER]: 'Менеджер',
  [USER_ROLES.OPERATOR]: 'Оператор',
  [USER_ROLES.VIEWER]: 'Просмотр',
  [USER_ROLES.USER]: 'Пользователь',
};

export const USER_ROLE_COLORS = {
  [USER_ROLES.SUPER_ADMIN]: 'purple',
  [USER_ROLES.PLATFORM_ADMIN]: 'gold',
  [USER_ROLES.OWNER]: 'red',
  [USER_ROLES.ADMIN]: 'orange',
  [USER_ROLES.MANAGER]: 'blue',
  [USER_ROLES.OPERATOR]: 'green',
  [USER_ROLES.VIEWER]: 'default',
  [USER_ROLES.USER]: 'default',
};

// =====================================
// Права доступа (на основе middleware)
// =====================================
export const PERMISSIONS = {
  // Товары
  PRODUCTS_VIEW: 'products.view',
  PRODUCTS_CREATE: 'products.create',
  PRODUCTS_UPDATE: 'products.update',
  PRODUCTS_DELETE: 'products.delete',
  PRODUCTS_IMPORT: 'products.import',
  PRODUCTS_EXPORT: 'products.export',

  // Группы товаров (вариации)
  PRODUCT_GROUPS_VIEW: 'product_groups.view',
  PRODUCT_GROUPS_CREATE: 'product_groups.create',
  PRODUCT_GROUPS_EDIT: 'product_groups.edit',
  PRODUCT_GROUPS_DELETE: 'product_groups.delete',
  PRODUCT_GROUPS_MANAGE_VARIATIONS: 'product_groups.manage_variations',

  // Заказы
  ORDERS_VIEW: 'orders.view',
  ORDERS_CREATE: 'orders.create',
  ORDERS_UPDATE: 'orders.update',
  ORDERS_DELETE: 'orders.delete',
  ORDERS_EXPORT: 'orders.export',

  // Маркетплейсы
  MARKETPLACES_VIEW: 'marketplaces.view',
  MARKETPLACES_CREATE: 'marketplaces.create',
  MARKETPLACES_UPDATE: 'marketplaces.update',
  MARKETPLACES_DELETE: 'marketplaces.delete',

  // Склады
  WAREHOUSES_VIEW: 'warehouses.view',
  WAREHOUSES_CREATE: 'warehouses.create',
  WAREHOUSES_UPDATE: 'warehouses.update',
  WAREHOUSES_DELETE: 'warehouses.delete',
  WAREHOUSES_TRANSFER: 'warehouses.transfer',

  // Поставщики
  SUPPLIERS_VIEW: 'suppliers.view',
  SUPPLIERS_CREATE: 'suppliers.create',
  SUPPLIERS_UPDATE: 'suppliers.update',
  SUPPLIERS_DELETE: 'suppliers.delete',

  // Импорт файлов (модуль /api/file-import — см. backend routes/fileImport.js, checkPermission)
  FILE_IMPORT_VIEW: 'file-import.view',
  FILE_IMPORT_CREATE: 'file-import.create',
  FILE_IMPORT_UPDATE: 'file-import.update',
  FILE_IMPORT_DELETE: 'file-import.delete',
  FILE_IMPORT_EXECUTE: 'file-import.execute',

  // Пользователи
  USERS_VIEW: 'users.view',
  USERS_CREATE: 'users.create',
  USERS_UPDATE: 'users.update',
  USERS_DELETE: 'users.delete',

  // Синхронизация
  SYNC_EXECUTE: 'sync.execute',
  SYNC_VIEW_LOGS: 'sync.view_logs',

  // Аналитика
  ANALYTICS_VIEW: 'analytics.view',
  ANALYTICS_EXPORT: 'analytics.export',
  ANALYTICS_ADMIN: 'analytics.admin',

  // Биллинг
  BILLING_VIEW: 'billing.view',
  BILLING_MANAGE: 'billing.manage',

  // Настройки (важно для страниц /settings/*, включая "Настройки цен")
  // На бэкенде большинство настроек защищено именно 'settings.update'
  SETTINGS_UPDATE: 'settings.update',
  // ⚠️ Совместимость: ранее в UI использовался SETTINGS_VIEW, но отдельного 'settings.view' в проекте сейчас нет.
  // Поэтому SETTINGS_VIEW пока указывает на тот же permission, что и SETTINGS_UPDATE.
  SETTINGS_VIEW: 'settings.update',

  // Касса (Kassa module — 12a)
  KASSA_VIEW: 'kassa.view',
  KASSA_REPORTS: 'kassa.reports',
  KASSA_SELL: 'kassa.sell',
  KASSA_REFUND: 'kassa.refund',
  KASSA_SHIFT_MANAGE: 'kassa.shift.manage',
  KASSA_MANAGE: 'kassa.manage',

  // Документооборот (Documents module)
  DOCUMENTS_VIEW: 'documents.view',
  DOCUMENTS_CREATE: 'documents.create',
  DOCUMENTS_UPDATE: 'documents.update',
  DOCUMENTS_DELETE: 'documents.delete',
  DOCUMENTS_MANAGE: 'documents.manage',

  // Соответствие (Compliance module)
  COMPLIANCE_VIEW: 'compliance.view',
  COMPLIANCE_ADMIN: 'compliance.admin',

  // Системные
  SYSTEM_ADMIN: 'system.admin',
  SYSTEM_VIEW: 'system.view',
  SYSTEM_MANAGE: 'system.manage',
  TENANT_ADMIN: 'tenant.admin',
  ADMIN_ACCESS: 'admin.access',
};

// =====================================
// Права по ролям (на основе middleware)
// =====================================

// Базовые права для user (минимальные права)
const USER_PERMISSIONS = [
  PERMISSIONS.PRODUCTS_VIEW,
  PERMISSIONS.ORDERS_VIEW,
  PERMISSIONS.WAREHOUSES_VIEW,
  PERMISSIONS.SUPPLIERS_VIEW,
  PERMISSIONS.FILE_IMPORT_VIEW,
  PERMISSIONS.DOCUMENTS_VIEW,
  PERMISSIONS.KASSA_VIEW,
  PERMISSIONS.KASSA_SELL,
];

// Права для viewer (просмотр)
const VIEWER_PERMISSIONS = [
  ...USER_PERMISSIONS,
  PERMISSIONS.MARKETPLACES_VIEW,
  PERMISSIONS.ANALYTICS_VIEW,
];

// Дополнительные права для operator
const OPERATOR_ADDITIONAL_PERMISSIONS = [
  PERMISSIONS.PRODUCTS_UPDATE,
  PERMISSIONS.ORDERS_UPDATE,
  PERMISSIONS.WAREHOUSES_TRANSFER,
  PERMISSIONS.SYNC_EXECUTE,
  PERMISSIONS.FILE_IMPORT_CREATE,
  PERMISSIONS.FILE_IMPORT_UPDATE,
  PERMISSIONS.FILE_IMPORT_EXECUTE,
];

// Дополнительные права для manager
const MANAGER_ADDITIONAL_PERMISSIONS = [
  PERMISSIONS.PRODUCTS_CREATE,
  PERMISSIONS.PRODUCTS_DELETE,
  PERMISSIONS.ORDERS_CREATE,
  PERMISSIONS.ORDERS_DELETE,
  PERMISSIONS.ORDERS_EXPORT,
  PERMISSIONS.WAREHOUSES_CREATE,
  PERMISSIONS.WAREHOUSES_UPDATE,
  PERMISSIONS.SUPPLIERS_UPDATE,
  PERMISSIONS.MARKETPLACES_UPDATE,
  PERMISSIONS.USERS_VIEW,
  PERMISSIONS.BILLING_VIEW,
  PERMISSIONS.DOCUMENTS_CREATE,
  PERMISSIONS.DOCUMENTS_UPDATE,
  PERMISSIONS.DOCUMENTS_DELETE,
  PERMISSIONS.DOCUMENTS_MANAGE,
  PERMISSIONS.KASSA_REFUND,
  PERMISSIONS.KASSA_SHIFT_MANAGE,
  PERMISSIONS.KASSA_REPORTS,
  PERMISSIONS.KASSA_MANAGE,
  PERMISSIONS.ANALYTICS_EXPORT,
  PERMISSIONS.FILE_IMPORT_DELETE,
];

// ✅ БЕЗОПАСНОСТЬ: Разделяем права компании и системные права
// Права компании - для owner и admin (БЕЗ доступа к системной админке)
const COMPANY_ADMIN_PERMISSIONS = Object.values(PERMISSIONS).filter(
  p => p !== PERMISSIONS.SYSTEM_ADMIN && p !== PERMISSIONS.ADMIN_ACCESS
);

// Полные права включая системные - ТОЛЬКО для super_admin
const FULL_SYSTEM_PERMISSIONS = Object.values(PERMISSIONS);

export const ROLE_PERMISSIONS = {
  [USER_ROLES.USER]: USER_PERMISSIONS,
  [USER_ROLES.VIEWER]: VIEWER_PERMISSIONS,
  [USER_ROLES.OPERATOR]: [
    ...VIEWER_PERMISSIONS,
    ...OPERATOR_ADDITIONAL_PERMISSIONS,
  ],
  [USER_ROLES.MANAGER]: [
    ...VIEWER_PERMISSIONS,
    ...OPERATOR_ADDITIONAL_PERMISSIONS,
    ...MANAGER_ADDITIONAL_PERMISSIONS,
  ],
  [USER_ROLES.ADMIN]: COMPANY_ADMIN_PERMISSIONS,  // ✅ БЕЗ системных прав
  [USER_ROLES.OWNER]: COMPANY_ADMIN_PERMISSIONS,  // ✅ БЕЗ системных прав
  [USER_ROLES.PLATFORM_ADMIN]: FULL_SYSTEM_PERMISSIONS,
  [USER_ROLES.SUPER_ADMIN]: FULL_SYSTEM_PERMISSIONS,  // ✅ Все права включая системные
};

// =====================================
// Маркетплейсы (на основе БД)
// =====================================
export const MARKETPLACES = {
  OZON: 'ozon',
  WILDBERRIES: 'wildberries',
  YANDEX_MARKET: 'yandex_market',
  AVITO: 'avito',
};

export const MARKETPLACE_LABELS = {
  [MARKETPLACES.OZON]: 'Ozon',
  [MARKETPLACES.WILDBERRIES]: 'Wildberries',
  [MARKETPLACES.YANDEX_MARKET]: 'Яндекс.Маркет',
  [MARKETPLACES.AVITO]: 'Avito',
};

export const MARKETPLACE_COLORS = {
  [MARKETPLACES.OZON]: '#005BFF',
  [MARKETPLACES.WILDBERRIES]: '#CB11AB',
  [MARKETPLACES.YANDEX_MARKET]: '#FFCC00',
  [MARKETPLACES.AVITO]: '#00D4AA',
};

// =====================================
// Поставщики (унифицированные типы)
// =====================================
export const SUPPLIER_TYPES = {
  API: 'api',        // API-поставщики (RS24, ETM, и др.)
  FILE: 'file',      // Файловые поставщики (CSV, XML, и др.)
  MANUAL: 'manual',  // Ручной ввод
};

export const SUPPLIER_TYPE_LABELS = {
  [SUPPLIER_TYPES.API]: 'API поставщик',
  [SUPPLIER_TYPES.FILE]: 'Файловый поставщик',
  [SUPPLIER_TYPES.MANUAL]: 'Ручной ввод',
};

// Для обратной совместимости
export const SUPPLIERS = {
  ETM: 'etm',
  RS24: 'rs24',
  MANUAL: 'manual',
};

export const SUPPLIER_LABELS = {
  [SUPPLIERS.ETM]: 'ETM',
  [SUPPLIERS.RS24]: 'RS24',
  [SUPPLIERS.MANUAL]: 'Ручной ввод',
};



// =====================================
// ✅ ФУНКЦИИ ДЛЯ РАБОТЫ С ПРАВАМИ
// =====================================

/**
 * Проверка наличия права у роли
 * @param {string} userRole - Роль пользователя
 * @param {string} permission - Требуемое право
 * @returns {boolean}
 */
export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;

  // ✅ БЕЗОПАСНОСТЬ: Проверяем права из списка прав роли
  // Owner и Admin НЕ имеют системных прав (ADMIN_ACCESS, SYSTEM_ADMIN)
  const rolePermissions = ROLE_PERMISSIONS[userRole] || [];
  return rolePermissions.includes(permission);
};

/**
 * Проверка наличия нескольких прав у роли
 * @param {string} userRole - Роль пользователя
 * @param {string[]} permissions - Массив требуемых прав
 * @param {boolean} requireAll - Требовать все права (true) или хотя бы одно (false)
 * @returns {boolean}
 */
export const hasPermissions = (userRole, permissions, requireAll = true) => {
  if (!userRole || !permissions || !Array.isArray(permissions)) return false;

  if (requireAll) {
    return permissions.every(permission => hasPermission(userRole, permission));
  } else {
    return permissions.some(permission => hasPermission(userRole, permission));
  }
};

/**
 * Проверка роли администратора компании (Super Admin, Owner или Admin)
 * @param {string} userRole - Роль пользователя
 * @returns {boolean}
 */
export const isAdmin = (userRole) => {
  return [USER_ROLES.SUPER_ADMIN, USER_ROLES.PLATFORM_ADMIN, USER_ROLES.OWNER, USER_ROLES.ADMIN].includes(userRole);
};

/**
 * Проверка роли суперадминистратора (доступ к системной админке)
 * @param {string} userRole - Роль пользователя
 * @returns {boolean}
 */
export const isSuperAdmin = (userRole) => {
  return [USER_ROLES.SUPER_ADMIN, USER_ROLES.PLATFORM_ADMIN].includes(userRole);
};

/**
 * Проверка роли владельца компании
 * @param {string} userRole - Роль пользователя
 * @returns {boolean}
 */
export const isOwner = (userRole) => {
  return userRole === USER_ROLES.OWNER;
};

/**
 * Получение всех прав роли
 * @param {string} userRole - Роль пользователя
 * @returns {string[]}
 */
export const getRolePermissions = (userRole) => {
  if (!userRole) return [];
  return ROLE_PERMISSIONS[userRole] || [];
};

// =====================================
// URL Утилиты
// =====================================

/**
 * Получение URL app поддомена
 * @param {string} path - Путь (например, '/login', '/register')
 * @returns {string} - Полный URL к app домену
 */
export const getAppDomainUrl = (path = '/') => {
  if (typeof window === 'undefined') {
    return path;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  // Разработка на loopback (127.0.0.1 / ::1)
  if (isLoopbackHost(hostname)) {
    return path;
  }

  // Если уже на app поддомене
  if (hostname.startsWith('app.')) {
    return path;
  }

  const appHostname = resolveMarkbaseProductionAppHostname(hostname);

  return `${protocol}//${appHostname}${path}`;
};

/**
 * Получение URL публичного сайта
 * @param {string} path - Путь (например, '/', '/about')
 * @returns {string} - Полный URL к публичному сайту
 */
export const getPublicDomainUrl = (path = '/') => {
  if (typeof window === 'undefined') {
    return path;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;

  if (isLoopbackHost(hostname)) {
    return path;
  }

  // Если на публичном домене
  if (!hostname.startsWith('app.') && !hostname.startsWith('www.')) {
    return path;
  }

  // Формируем URL для публичного домена (убираем app.)
  const publicHostname = hostname.replace('app.', '').replace('www.', '');

  return `${protocol}//${publicHostname}${path}`;
};

/**
 * Получение URL микросервиса UAM (тот же источник, что Login/Register: REACT_APP_UAM_URL → UAM_URL).
 * Не использовать эвристику «auth.» + последние две метки hostname — она даёт неверные хосты (например auth.ru).
 * @param {string} path - Путь API (например, '/api/uam/v1/unlock/status')
 * @returns {string} - Полный абсолютный URL к UAM
 */
export const getAuthDomainUrl = (path = '') => {
  const normalizedPath = path === '' ? '' : (path.startsWith('/') ? path : `/${path}`);

  if (typeof window === 'undefined') {
    return `${UAM_URL}${normalizedPath}`;
  }

  const hostname = window.location.hostname;
  const isLocal = isLoopbackHost(hostname);

  let base = UAM_URL;
  if (isLocal) {
    base = process.env.REACT_APP_UAM_URL
      ? String(process.env.REACT_APP_UAM_URL).replace(/\/+$/, '')
      : 'http://127.0.0.1:8060';
  }

  return `${base}${normalizedPath}`;
};

// =====================================
// Public Landing: Быстрые вопросы и ответы (используется на главной и в Документации)
// Источник: публичная markdown-документация репозитория (aidock/*) + эталон
// PLATFORM_ETALON_I_UNIFIKACIYA_DANNYH/masterplan/MARKBASE_EDINAYA_POLNAYA_DOKUMENTACIYA.md
// =====================================
export const PUBLIC_DOCS_QUICK_FAQ = [
  {
    id: 'start',
    q: 'С чего начать работу в Markbase?',
    a: 'Выберите сценарий: собственный каталог (ручной ввод или импорт из Excel/CSV/XML), потоки от поставщиков (API или файлы) или двусторонние интеграции с маркетплейсами. Источники сочетаются и приводятся к единым справочникам платформы.',
  },
  {
    id: 'add-products',
    q: 'Как добавить товары в систему?',
    a: 'Товары можно добавить вручную или импортировать из файла. Тяжёлые загрузки выполняются в фоне, чтобы менеджеры не ждали зависшего экрана. Прогресс и ошибки видны в разделе «Процессы».',
  },
  {
    id: 'suppliers',
    q: 'Как подключить поставщика и скачать его товары?',
    a: 'Откройте «Поставщики» → «Добавить поставщика», выберите тип подключения (API/файл/ручной), сохраните и запустите синхронизацию позиций, цен и остатков. Поля приводятся к единым справочникам компании.',
  },
  {
    id: 'mapping',
    q: 'Что такое маппинг и зачем он нужен?',
    a: 'Маппинг — это сопоставление данных поставщика (бренд, категория, атрибуты) с вашими справочниками. Сильнейшие сигналы — штрихкод и артикул, дополнительно используются бренд и ветка категорий. Полная автоматика на «грязных» данных недостижима — это осознанная граница.',
  },
  {
    id: 'accept-products',
    q: 'Как принять товары поставщика в свою базу?',
    a: 'После скачивания откройте «Импорт товаров» → «Товары поставщиков», выделите нужные позиции и нажмите «Принять выбранные». При необходимости настройте создание брендов/категорий и условия слияния по штрихкоду/артикулу.',
  },
  {
    id: 'marketplaces',
    q: 'Что такое двусторонние интеграции с маркетплейсами?',
    a: 'Это не только выгрузка карточек, цен и остатков на площадку, но и обратный забор заказов и существующих карточек. Чужие карточки сначала видны для проверки и сопоставления, а только после вашего решения — становятся частью каталога.',
  },
  {
    id: 'logistics-wms',
    q: 'Чем отличаются логистика и WMS?',
    a: 'Логистика — это торговая цепочка: какие склады участвуют в резервировании и отгрузке, как доступность связана с витриной. WMS — уровень глубже: зоны, ячейки, задания на перемещение, инвентаризация. Карточка склада общая — двух «правд» не существует.',
  },
  {
    id: 'orders-flow',
    q: 'Как заказ связан с остальными модулями?',
    a: 'Заказ хранит ссылки на товары и зафиксированные цены, не дублируя каталог. Из него развиваются отгрузка (склад), доставка, оплата (финансы), чек на кассе, документы и ЭДО, уведомления. Это сквозной процесс «продал → отгрузил → получил оплату → отразил в документах».',
  },
  {
    id: 'ai-context',
    q: 'Как ВЭЙГПТ работает с моими данными?',
    a: 'AI-контур платформы привязан к компании и тарифу. Контексты разных организаций не смешиваются, расход учитывается через биллинг и баланс. Универсальный ассистент работает в витрине и CRM; генератор контента — в маркетинговых сценариях.',
  },
  {
    id: 'security',
    q: 'Как защищены данные разных компаний?',
    a: 'Разделение по company-context: данные, файлы, роли и доступы изолированы. Публичные страницы не раскрывают токены и приватные данные, а внутренние сервисы общаются по явным контрактам и токенам.',
  },
  {
    id: 'pricing',
    q: 'Как устроена оплата и тариф?',
    a: 'Тариф и лимиты привязаны к организации; подключение модулей и расширенные функции учитываются раздельно. Баланс компании используется для платных операций (включая ИИ). Конкретные цифры — на странице тарифов и в договоре.',
  },
  {
    id: 'where-help',
    q: 'Где найти подробные инструкции по модулям и сценариям?',
    a: 'Слева — навигация по разделам (aidock, docs и их подкаталогам). Используйте поиск по заголовкам и путям, чтобы быстро найти нужный гайд. На странице «Главная» собраны опоры платформы, а «О платформе» — единое полотно с описанием контуров.',
  },
];

// =====================================
// Складские статусы товаров (UI labels)
// =====================================
export const WAREHOUSE_STATUS_LABELS = {
  'СКЛ': 'Склад',
  'ЗКЗ': 'Заказ',
  'ОСТ': 'Остаток',
  'СЕЗ': 'Сезонный',
  'ИНД': 'Индивидуальный',
  'НОВ': 'Новый',
};

export const formatWarehouseStatusName = (code) => {
  const c = (code != null ? String(code) : '').trim().toUpperCase();
  if (!c) return '';
  return WAREHOUSE_STATUS_LABELS[c] || c;
};